const { create } = require('zustand');

export const useHubspotStore = create((set) => ({
  settingsModalOpen: false,
  openSettings: () => set(() => ({ settingsModalOpen: true })),
  closeSettings: () => set(() => ({ settingsModalOpen: false })),
  isEnabled: false,
  setIsEnabled: (isEnabled) => set(() => ({ isEnabled })),
}));
